/* eslint-disable */
// The below object just explains the structure and is not used anywhere
const techInterpretationStructure = {
    base:{
        rhythm_id: "",
        rhythm_name: "",
        bpm:null,
    },
    intervals:[         // ===> Will be mapped to the redux state
        {
            start:0,                // Start "i" value of the interval ( sample array index )
            end:0,                  // End "i" value of the interval ( sample array index )
            time:{ 
                start:0,            // start time in seconds
                end:0,              // end time in seconds
            },
            type: {
                id:'',              // type id from backed
                name:'',            // type name from backend
            },
            position:[0,0,0,0],     // this is the start and end coordinated in the graph. WILL BE REMOVED DOWN THE LANE
            bpm: {                  // BPM for the interval
                min: 0,
                max: 0,
                average: 0,
            },
            beat_count: 0,       // Contains the number of beats inside the interval
        },
    ],
    veBeatCount: 0,
}


export const printTechIntrString = (techIntrObj, characters = 50) => {
    let resultStr = ''
    const obj = JSON.parse(techIntrObj)
    const showBaseRhythm = false;
    if(Array.isArray(obj)){
        // console.log("==== V1 Object ====")
        if (obj.length) {
            obj.forEach(interpretation => {
            if (interpretation.type.name === 'Pause') {
                resultStr = resultStr !== '' ? resultStr + ', ' : '';
                resultStr = resultStr + `${interpretation.type.name} ${(interpretation.time.end - interpretation.time.start).toFixed(2)} seconds`
            } else {
                resultStr = resultStr !== '' ? resultStr + ', ' : '';
                if (interpretation.bpm) {
                resultStr = resultStr + `${interpretation.type.name} (${interpretation.bpm.average}, ${interpretation.bpm.min}-${interpretation.bpm.max} bpm)`
                } else {
                resultStr = resultStr + `${interpretation.type.name}`
                }
            }
            })
        }
    } else {
        // console.log("==== V2 Object ====", obj.base)
        // Base rhythm ----
        if(obj && obj.base && obj.base.rhythm_name && showBaseRhythm) {
            resultStr = resultStr + obj.base.rhythm_name 
            if(obj.base.bpm) {
                resultStr = resultStr + `(${obj.base.bpm} bpm)`
            }
        }
        // Interpretation ----
        if (obj && obj.intervals && obj.intervals.length) {
            obj.intervals.forEach(interpretation => {
            if (interpretation.type.name === 'Pause') {
                resultStr = resultStr !== '' ? resultStr + ', ' : '';
                resultStr = resultStr + `${interpretation.type.name} ${(interpretation.time.end - interpretation.time.start).toFixed(2)} seconds`
            } else {
                resultStr = resultStr !== '' ? resultStr + ', ' : '';
                if (interpretation.bpm) {
                resultStr = resultStr + `${interpretation.type.name} (${interpretation.bpm.average}, ${interpretation.bpm.min}-${interpretation.bpm.max} bpm)`
                } else {
                resultStr = resultStr + `${interpretation.type.name}`
                }
            }
            })
        }
        // Ve Beats ----
        if(obj.veBeatCount > 0) {
            resultStr = resultStr == '' ? resultStr + "VE(s)" : resultStr + ", VE(s)";
        }
        if(obj.sveBeatCount && obj.sveBeatCount > 0) {
            resultStr = resultStr == '' ? resultStr + "SVE(s)" : resultStr + ", SVE(s)";
        }
    }

    // console.log(resultStr)
    return resultStr
}

export const parseTechIntrObj = (techIntrObj) => {
    //  if techIntrObj an object 
        // then its v2 perform v2 print 
    //  else techIntrObj an array
        //  perform v1 print 
}


// WEBPACK FOOTER //
// ./src/views/pages/Annotation/utils/TechIntrParser.js